import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalPageLuxe from './LegalPageLuxe';

// Texte du fondateur (docs/legal, 2026-10-30), corrige sur le fonctionnement REEL avant publication :
// - durees (art. 7) : celles appliquees par backend/services/accounts/retentionPurge.js (60 jours sans compte, 12 mois non finalise,
//   jamais un livre commande), emailJournal.purger (12 mois), purgeEvents (90 jours), sauvegardes (14 j serveur + 30 j hors serveur),
//   journaux Caddy (90 jours par defaut). Le brouillon promettait une suppression des comptes apres 3 ans d'inactivite : NON programmee,
//   donc retiree (a coder avant de la reecrire ici) ;
// - pas de lettre d'information ni de panier : retires ; personnes invitees et formulaire de contact : ajoutes.
// Sous-traitants : Scaleway, Stripe, Gelato, Prodigi, Brevo, Supabase (transition).
export default function ConfidentialiteLuxe() {
  const { t } = useTranslation('legal');
  const sections = t('confidentialite.sections', { returnObjects: true });
  return (
    <LegalPageLuxe
      title={t('confidentialite.title')}
      updated={t('confidentialite.updated')}
      intro={t('confidentialite.intro')}
      sections={Array.isArray(sections) ? sections : []}
    />
  );
}
